import { useEffect } from "react";
import { PAGES, SITE_NAME, absolute, OG_DEFAULT_IMAGE, breadcrumbSchema } from "../lib/seo";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Per-route document head: title, description, canonical, Open Graph / Twitter, JSON-LD.
export const Seo = ({ page, meta: metaProp, jsonLd = [], breadcrumbs }) => {
  const meta = metaProp || PAGES[page];

  // Build-time prerender (scripts/prerender.mjs): collect head data during server render.
  if (typeof window === "undefined" && globalThis.__SEO_COLLECT__) {
    const schemas = [...jsonLd];
    if (breadcrumbs) schemas.push(breadcrumbSchema([["Home", "/"], ...breadcrumbs]));
    globalThis.__SEO_COLLECT__.push({ ...meta, url: absolute(meta.path), image: OG_DEFAULT_IMAGE, jsonLd: schemas });
  }

  useEffect(() => {
    const url = absolute(meta.path);
    document.title = meta.title;
    setMeta("name", "description", meta.description);
    if (meta.keywords) setMeta("name", "keywords", meta.keywords);
    setMeta("name", "robots", meta.noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setLink("canonical", url);

    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:locale", "en_US");
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", OG_DEFAULT_IMAGE);
    setMeta("property", "og:image:alt", "Bathymetric depth map of a reservoir by Lake Monitor AI");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", meta.description);
    setMeta("name", "twitter:image", OG_DEFAULT_IMAGE);

    const schemas = [...jsonLd];
    if (breadcrumbs) schemas.push(breadcrumbSchema([["Home", "/"], ...breadcrumbs]));
    document.head.querySelectorAll('script[data-seo="route"]').forEach((s) => s.remove());
    schemas.forEach((schema) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.seo = "route";
      s.text = JSON.stringify(schema);
      document.head.appendChild(s);
    });
  }, [meta, jsonLd, breadcrumbs]);

  return null;
};
